// Reduce una imagen subida por el usuario a un JPEG ligero (data URL).
// Las fotos de móvil pesan varios MB; guardarlas tal cual en Mongo hace que cada listado que las incluye
// descargue decenas de MB. Aquí se limita el lado mayor y se recomprime ANTES de enviarlas al backend.

const readAsDataUrl = (file) => new Promise((resolve, reject) => {
  const r = new FileReader();
  r.onload = () => resolve(r.result);
  r.onerror = () => reject(r.error || new Error("No se pudo leer el archivo"));
  r.readAsDataURL(file);
});

const loadImage = (src) => new Promise((resolve, reject) => {
  const img = new Image();
  img.onload = () => resolve(img);
  img.onerror = () => reject(new Error("Imagen no válida"));
  img.src = src;
});

const SMALL_ENOUGH_BYTES = 300 * 1024;

/**
 * @param {File} file
 * @param {{maxSize?: number, quality?: number}} opts  lado mayor máximo en px y calidad JPEG (0-1)
 * @returns {Promise<string>} data URL (image/jpeg), o el original si ya es pequeño
 * @throws si no es una imagen o no se puede decodificar (el llamador debe avisar al usuario)
 */
export async function fileToResizedDataUrl(file, { maxSize = 800, quality = 0.8 } = {}) {
  if (!file || !/^image\//.test(file.type || "")) throw new Error("El archivo no es una imagen");
  const original = await readAsDataUrl(file);
  const img = await loadImage(original);
  const { naturalWidth: w0, naturalHeight: h0 } = img;
  if (!w0 || !h0) throw new Error("Imagen no válida");
  // Ya es pequeña (dimensiones y peso): no la recomprimimos para no perder calidad.
  if (w0 <= maxSize && h0 <= maxSize && file.size <= SMALL_ENOUGH_BYTES) return original;
  const scale = Math.min(1, maxSize / Math.max(w0, h0));
  const w = Math.max(1, Math.round(w0 * scale));
  const h = Math.max(1, Math.round(h0 * scale));
  const canvas = document.createElement("canvas");
  canvas.width = w; canvas.height = h;
  const ctx = canvas.getContext("2d");
  ctx.fillStyle = "#ffffff";            // PNG con transparencia -> fondo blanco (JPEG no tiene alfa)
  ctx.fillRect(0, 0, w, h);
  ctx.drawImage(img, 0, 0, w, h);
  return canvas.toDataURL("image/jpeg", quality);
}
